(() => {
  const desktop = window.matchMedia('(min-width: 992px)');

  const products = {
    'jill-leen-colorful-soft-mist-blush-3g-matte-pearlescent-face-cheek-brightening-makeup-for-20-30': {
      title: 'Colorful Soft Mist Blush', category: 'Powder blusher', benefit: 'Soft-focus color in matte and pearlescent finishes.', modelIndex: 23, productIndex: 43, modelPosition: 'center center', productFit: 'cover', productPosition: 'center top', cleanCrop: true
    },
    'jillleen-blush-cream-mousse-lavender-blush-brightening-lifting-long-lasting-natural-finish-moisturizing-skin-friendly-contouring-healthy-glow': {
      title: 'Blush Cream & Mousse', category: 'Blush', benefit: 'Buildable cream color with a fresh, softly sculpted finish.', modelIndex: 17, productIndex: 42, modelPosition: 'center center'
    },
    'jill-leen-setting-spray-oil-control-hydrating-quick-setting-waterproof-sweat-resistant-moisturizing-long-lasting-makeup-lock': {
      title: 'Makeup Setting Spray', category: 'Setting spray', benefit: 'A lightweight mist that helps makeup stay fresh for longer.', modelIndex: 4, productIndex: 5, modelFit: 'contain', modelPosition: 'center center', fallback: true
    },
    'jill-leen3-color-contour-palette-matte-shading-nose-contour-side-contour-highlighter-brightening-all-in-one': {
      title: '3-Color Contour Palette', category: 'Contour', benefit: 'Three balanced tones for softly defined, natural-looking dimension.', modelIndex: 3, productIndex: 10, modelPosition: '38% center'
    },
    'jill-leen新品九色眼影盘女美瑛珠光提亮-带闪-自然立体彩妆便携': {
      title: 'Nine-Color Eyeshadow Palette', category: 'Eyeshadow', benefit: 'Nine coordinated shades for soft definition and shimmer.', modelIndex: 1, productIndex: 0, modelPosition: '78% center'
    },
    'jill-leen炫色迷你眼影盘燕麦哑珠光亮片闪粉-微醺酒红色眼妆修容': {
      title: 'Colorful Mini Eyeshadow Palette', category: 'Eyeshadow', benefit: 'Compact everyday color with matte and sparkling finishes.', modelIndex: 1, productIndex: 0, modelPosition: '72% center'
    },
    'jill-leen眼影小盘便携番茄炒蛋哑光风铃郁金香珠光新套装平价女': {
      title: 'Mini Eyeshadow Palette', category: 'Eyeshadow', benefit: 'A portable edit of easy matte and luminous shades.', modelIndex: 0, productIndex: 0, modelFit: 'contain', fallback: true
    },
    'jill-leen迷你九色眼影盘便携黄色绿色蓝色亮片珠光哑光闪粉眼影': {
      title: 'Colorful Nine-Color Palette', category: 'Eyeshadow', benefit: 'Playful color in a compact mix of matte and shimmer.', modelIndex: 0, productIndex: 0, modelFit: 'contain', fallback: true
    },
    'jill-leen炫色迷你眼影盘便携-粉棕温柔系裸妆初学者偏光大地色女': {
      title: 'Soft Brown Mini Palette', category: 'Eyeshadow', benefit: 'Wearable pink-brown tones for effortless everyday looks.', modelIndex: 0, productIndex: 0, modelFit: 'contain', fallback: true
    },
    'jill-leen三色平衡遮瑕膏遮盖斑点-遮瑕黑眼圈痘印脸部提亮': {
      title: '3-Color Balancing Concealer', category: 'Concealer', benefit: 'Three correcting tones for a more even-looking complexion.', modelIndex: 0, productIndex: 0, modelFit: 'contain', fallback: true
    },
    'jill-leen塑形雾感眉笔女防水不易晕染撕拉眉笔木质硬芯自然持久': {
      title: 'Soft Mist Eyebrow Pencil', category: 'Eyebrow', benefit: 'A precise, natural-looking pencil with lasting definition.', modelIndex: 4, productIndex: 4, modelFit: 'contain', fallback: true
    },
    'jill-leen新品多功能眼影盘-高光修容阴影腮红新手哑光珠光彩妆盘': {
      title: 'Multi-Use Face & Eye Palette', category: 'Face palette', benefit: 'A compact edit of eye, blush, contour and highlight tones.', modelIndex: 3, productIndex: 0, modelPosition: '76% center'
    },
    '精细笔头jill-leen炫色眼线液笔防水-流畅速干抗晕不掉渣新手好画': {
      title: 'Precision Liquid Eyeliner', category: 'Eyeliner', benefit: 'A fine-tip liner for controlled, fluid definition.', modelIndex: 1, productIndex: 0, modelPosition: '76% center'
    },
    'jill-leen十二色眼影盘漂亮盘-哑光奶茶色系日常温柔通勤新品': {
      title: 'Twelve-Color Eyeshadow Palette', category: 'Eyeshadow', benefit: 'Soft neutral shades designed for polished everyday looks.', modelIndex: 1, productIndex: 0, modelPosition: '75% center'
    },
    'jill-leen双色修容粉饼阴影鼻影瘦脸遮瑕哑光提亮立体高光一体盘': {
      title: 'Dual-Color Contour Powder', category: 'Contour', benefit: 'A two-tone powder for subtle shadow and balanced highlight.', modelIndex: 1, productIndex: 0, modelPosition: '76% center'
    }
  };

  const handle = () => decodeURIComponent(location.pathname.split('/').filter(Boolean).pop() || '');

  const imageUrl = (image) => {
    const source = typeof image === 'string' ? image : image && image.src;
    if (!source) return '';
    return source.startsWith('//') ? `https:${source}` : source;
  };

  const domImages = () => {
    const seen = new Set();
    return [...document.querySelectorAll('.product-photos img')]
      .filter((image) => !image.classList.contains('jillleen-pdp-product-visual__image'))
      .map((image) => image.getAttribute('data-src') || image.currentSrc || image.src)
      .map(imageUrl)
      .filter((source) => source && !source.includes('_compact') && !seen.has(source) && seen.add(source));
  };

  const createText = (shop, selector, tag, text, anchor, position) => {
    let node = shop.querySelector(selector);
    if (!node) {
      node = document.createElement(tag);
      node.className = selector.slice(1);
      node.dataset.jillleenSplitCreated = 'true';
      if (anchor && position === 'after') anchor.insertAdjacentElement('afterend', node);
      else if (anchor) anchor.insertAdjacentElement('beforebegin', node);
      else shop.prepend(node);
    }
    node.textContent = text;
    return node;
  };

  const buildText = (product, config) => {
    const shop = document.querySelector('.product-shop');
    if (!shop) return;
    const originalTitle = shop.querySelector('.group-title');
    const prices = shop.querySelector('.prices');
    createText(shop, '.jillleen-pdp-eyebrow', 'p', config.category || product.type || 'JILL LEEN', originalTitle, 'before');
    createText(shop, '.jillleen-pdp-title', 'h1', config.title || product.title, originalTitle, 'before');
    createText(shop, '.jillleen-pdp-benefit', 'p', config.benefit || 'Designed for expressive, effortless color.', prices, 'after');
  };

  const buildVisual = (product, config) => {
    const host = document.querySelector('.product_top > .product-photos');
    if (!host) return false;
    host.querySelector('.jillleen-pdp-split-visual')?.remove();

    const images = (product.images || []).map(imageUrl).filter(Boolean);
    const fallbackImages = domImages();
    const sources = images.length ? images : fallbackImages;
    if (!sources.length) return false;

    const modelSource = sources[config.modelIndex] || sources[1] || sources[0];
    const productSource = sources[config.productIndex] || sources[0] || modelSource;
    const visual = document.createElement('div');
    visual.className = 'jillleen-pdp-split-visual';
    visual.innerHTML = `
      <figure class="jillleen-pdp-split-visual__panel jillleen-pdp-split-visual__panel--model${config.fallback ? ' is-product-fallback' : ''}">
        <img class="jillleen-pdp-split-visual__image jillleen-pdp-split-visual__image--model" src="${modelSource}" alt="${config.fallback ? `${config.title} detail` : `${config.title} model application`}">
      </figure>
      <figure class="jillleen-pdp-split-visual__panel jillleen-pdp-split-visual__panel--product">
        <div class="jillleen-pdp-split-visual__product-frame${config.cleanCrop ? ' is-clean-crop' : ''}">
          <img class="jillleen-pdp-split-visual__image jillleen-pdp-split-visual__image--product" src="${productSource}" alt="${config.title} product">
        </div>
      </figure>`;

    const modelImage = visual.querySelector('.jillleen-pdp-split-visual__image--model');
    const productImage = visual.querySelector('.jillleen-pdp-split-visual__image--product');
    modelImage.style.objectFit = config.modelFit || 'cover';
    modelImage.style.objectPosition = config.modelPosition || 'center center';
    productImage.style.objectFit = config.productFit || 'contain';
    productImage.style.objectPosition = config.productPosition || 'center center';
    host.prepend(visual);
    return true;
  };

  const loadProduct = async () => {
    try {
      const response = await fetch(`${location.pathname}.js`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Product JSON unavailable');
      return await response.json();
    } catch (error) {
      const title = document.querySelector('.product-title')?.textContent?.trim() || document.title;
      return { title, type: '', images: domImages() };
    }
  };

  const activate = async () => {
    if (!document.body.classList.contains('template-product')) return;
    const productHandle = handle();
    const config = products[productHandle] || {
      title: document.querySelector('.product-title')?.textContent?.trim() || 'JILL LEEN',
      category: 'JILL LEEN',
      benefit: 'Designed for expressive, effortless color.',
      modelIndex: 1,
      productIndex: 0,
      modelPosition: '72% center'
    };
    const product = await loadProduct();
    if (!desktop.matches) return;
    if (!buildVisual(product, config)) return;
    buildText(product, config);
    document.body.classList.add('jillleen-pdp-minimal-ready', 'jillleen-pdp-product-only-ready', 'jillleen-pdp-split-ready');
  };

  const deactivate = () => {
    document.querySelector('.jillleen-pdp-split-visual')?.remove();
    document.querySelectorAll('[data-jillleen-split-created="true"]').forEach((node) => node.remove());
    document.body.classList.remove('jillleen-pdp-split-ready');
  };

  const update = () => desktop.matches ? activate() : deactivate();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
  desktop.addEventListener?.('change', update);
})();
